import type { EventDefinition } from "../types";

type InterventionIdTypes = "duid"; // Add more values as needed

export type InterventionPayload = {
  interventionId: string;
  interventionName: string;
  userUniqueIdentifier: string;
  userUniqueIdentifierType: InterventionIdTypes;
  action: string;
  site?: string;
};

export const interventionEventDefinitions: EventDefinition[] = [
  {
    name: "interventionInteractionCompleted",
    type: "unstructured",
    makePayload: params => {
      const {
        interventionName,
        userUniqueIdentifier,
        userUniqueIdentifierType,
        action,
        site,
      } = params as InterventionPayload;

      return {
        schema:
          "iglu:com.simplybusiness/intervention_interaction_completed/jsonschema/2-1-0",
        data: {
          intervention_name: interventionName,
          user_unique_identifier: userUniqueIdentifier,
          user_unique_identifier_type: userUniqueIdentifierType,
          action,
          site,
        },
      };
    },
  },
];
